import React from 'react'

const GarantiePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-3xl font-bold mb-8 text-center">Garantiebedingungen</h1>
        
        <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
          <div className="text-center bg-indigo-50 p-6 rounded-lg">
            <h2 className="text-2xl font-semibold mb-2 text-indigo-800">PhoneMedic – Garantiebedingungen</h2>
            <p className="text-gray-700">
              Umfassende Garantieleistungen für Ihre Reparaturen
            </p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              1. Garantieumfang
            </h2>
            <div className="space-y-4">
              <div className="bg-green-50 p-6 rounded-lg border border-green-200">
                <h3 className="text-lg font-semibold mb-3 text-green-800">Unsere Garantieleistung</h3>
                <div className="space-y-3 text-gray-700">
                  <p>
                    PhoneMedic gewährt auf das reparierte Gerät eine <strong className="text-green-700">freiwillige Garantie von 12 Monaten</strong> ab Rechnungsdatum 
                    (bei normalen Reparaturen). Diese Garantie gilt <strong>ausschließlich für das auf der Rechnung genannte Gerät</strong> und ist 
                    <strong> nicht auf andere Geräte übertragbar</strong>.
                  </p>
                  <p className="bg-white p-3 rounded border-l-4 border-green-400">
                    <strong>Nachweis:</strong> Als Nachweis gilt die <strong>Originalrechnung von PhoneMedic</strong>. 
                    Eine Garantieleistung ist nur mit gültigem Kaufbeleg möglich.
                  </p>
                </div>
              </div>
              
              <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
                <p className="text-sm text-yellow-800">
                  <span className="font-semibold">Hinweis:</span> Für Diagnose- und Kostenvoranschlag-Services wird keine Garantie gewährt, 
                  da diese lediglich der Fehlerermittlung dienen.
                </p>
              </div>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              2. Von der Garantie ausgeschlossen sind:
            </h2>
            
            <div className="grid md:grid-cols-2 gap-4 mb-6">
              <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-200">
                <h4 className="font-semibold text-indigo-800 mb-2">Schäden durch unsachgemäßen Gebrauch</h4>
                <ul className="text-sm text-gray-700 space-y-1">
                  <li>• Fahrlässigkeit oder Vorsatz</li>
                  <li>• Nicht fachgerechte Installation</li>
                  <li>• Unsachgemäße Bedienung oder Pflege</li>
                </ul>
              </div>
              
              <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-200">
                <h4 className="font-semibold text-indigo-800 mb-2">Äußere Einflüsse</h4>
                <ul className="text-sm text-gray-700 space-y-1">
                  <li>• Sturz oder Stoßschäden</li>
                  <li>• Flüssigkeitsschäden</li>
                  <li>• Feuer, Blitzschlag, Überspannung</li>
                  <li>• Höhere Gewalt</li>
                </ul>
              </div>
              
              <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-200">
                <h4 className="font-semibold text-indigo-800 mb-2">Verschleißteile & Zubehör</h4>
                <ul className="text-sm text-gray-700 space-y-1">
                  <li>• Akku und Batterie</li>
                  <li>• Display und Beleuchtung</li>
                  <li>• Tastatur und Maus</li>
                  <li>• Sonstiges Zubehör</li>
                </ul>
              </div>
              
              <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-200">
                <h4 className="font-semibold text-indigo-800 mb-2">Ästhetische Mängel</h4>
                <ul className="text-sm text-gray-700 space-y-1">
                  <li>• Kratzer und Verfärbungen</li>
                  <li>• Lackschäden</li>
                  <li>• Normale Abnutzungserscheinungen</li>
                </ul>
              </div>
            </div>
            
            <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-200">
              <h4 className="font-semibold text-indigo-800 mb-2">Weitere Ausschlüsse</h4>
              <div className="grid md:grid-cols-2 gap-4 text-sm text-gray-700">
                <ul className="space-y-1">
                  <li>• Geräte mit fehlender oder unlesbarer Seriennummer</li>
                  <li>• Folge- oder Vermögensschäden (z.B. Datenverlust)</li>
                </ul>
                <ul className="space-y-1">
                  <li>• Schäden durch unsachgemäßen Versand/Verpackung</li>
                  <li>• Softwareprobleme ohne Hardwaredefekt</li>
                </ul>
              </div>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              3. Leihgerät bei längerer Reparaturdauer
            </h2>
            <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
              <h3 className="text-lg font-semibold mb-3 text-blue-800">Optional verfügbar (falls angeboten)</h3>
              <div className="space-y-3 text-gray-700">
                <p>
                  Bei Reparaturen mit einer Dauer von <strong>mehr als 3 Werktagen</strong> kann auf Wunsch ein 
                  <strong className="text-blue-700"> Leihgerät</strong> zur Verfügung gestellt werden.
                </p>
                <div className="bg-white p-4 rounded border-l-4 border-blue-400">
                  <h4 className="font-semibold mb-2">Bedingungen für Leihgeräte:</h4>
                  <ul className="text-sm space-y-1">
                    <li>• Verfügbarkeit nach Absprache</li>
                    <li>• Kaution kann erforderlich sein</li>
                    <li>• Sorgfältiger Umgang erforderlich</li>
                    <li>• Rückgabe bei Reparaturabholung</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              4. Garantieabwicklung
            </h2>
            <div className="space-y-4">
              <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-200">
                <h4 className="font-semibold text-indigo-800 mb-2">So machen Sie Garantieansprüche geltend:</h4>
                <ol className="list-decimal list-inside text-gray-700 space-y-1">
                  <li>Kontaktaufnahme mit PhoneMedic per E-Mail oder Telefon</li>
                  <li>Vorlage der Originalrechnung als Garantienachweis</li>
                  <li>Beschreibung des aufgetretenen Problems</li>
                  <li>Einsendung des Geräts nach Absprache</li>
                  <li>Kostenlose Reparatur bei berechtigten Garantieansprüchen</li>
                </ol>
              </div>
              
              <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                <p className="text-green-800">
                  <strong>Unser Versprechen:</strong> Bei berechtigten Garantiefällen übernehmen wir die Reparaturkosten vollständig, 
                  einschließlich Rückversand.
                </p>
              </div>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              5. Kontakt für Garantiefälle
            </h2>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-semibold mb-3">Kontaktinformationen</h4>
                  <div className="space-y-2 text-gray-700">
                    <p><strong>Telefon:</strong> +49 (0) 160 5010907</p>
                    <p><strong>E-Mail:</strong> service@phone-medic.de</p>
                    <p><strong>Servicezeiten:</strong> Mo-Fr 9:00-18:00 Uhr</p>
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold mb-3">Einsende-Adresse</h4>
                  <div className="text-gray-700">
                    <p>PhoneMedic</p>
                    <p>Konrad Blersch</p>
                    <p>Wahlenstraße 27</p>
                    <p>93047 Regensburg</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t pt-6">
            <div className="flex items-start space-x-3">
              <span className="text-green-500 text-xl">✓</span>
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">Ihr Vorteil bei PhoneMedic</h3>
                <p className="text-gray-700 text-sm">
                  Wir stehen für Qualität und Service. Unsere freiwillige Garantie zeigt unser Vertrauen in unsere Arbeit 
                  und gibt Ihnen die Sicherheit, die Sie verdienen. Bei Fragen stehen wir Ihnen jederzeit gerne zur Verfügung.
                </p>
              </div>
            </div>
          </div>
          
          <div className="border-t pt-6">
            <p className="text-sm text-gray-600">
              Stand: Januar 2025 | PhoneMedic - Konrad Blersch<br />
              Diese Garantiebedingungen gelten ergänzend zu den gesetzlichen Gewährleistungsrechten.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GarantiePage